import React, { Component } from "react"
import { Col } from "react-bootstrap"
import Measure from "react-measure"

import "./styles/winnerSheepStyles.css"
import sheepMale from "../../../../src/assets/sheepMale.svg"
import sheepFemale from "../../../../src/assets/sheepFemale.svg"

const noBlurStyle = {
  filter: "blur(0px)",
  WebkitFilter: "blur(0px)",
  MozFilter: "blur(0px)",
  OFilter: "blur(0px)",
  msFilter: "blur(0px)",
  transition: "all .5s ease",
}

class WinnerSheep extends Component {
  constructor() {
    super()

    this.state = {
      blurStyle: {
        filter: "blur(30px)",
        WebkitFilter: "blur(30px)",
        MozFilter: "blur(30px)",
        OFilter: "blur(30px)",
        msFilter: "blur(30px)",
        transition: "all .5s ease",
      },
      imageDimensions: null,
    }
  }

  renderSheep(player, opacity) {
    let svgSource = player.gender === 1 ? sheepMale : sheepFemale

    if (player.baabaatar && player.baabaatar.render) {
      svgSource = player.baabaatar.render
    }

    return (
      <Measure
        onMeasure={(dimensions) => {
          this.setState({ imageDimensions: dimensions })
        }}
      >
        <div className="baabaatarContainer">
          <img alt="" src={svgSource} />
        </div>
      </Measure>
    )
  }

  render() {
    const { player, opacity, subtitle } = this.props

    return (
      <Col
        sm={12}
        lg={12}
        onClick={() =>
          this.setState({
            blurStyle: noBlurStyle,
          })
        }
        style={this.state.blurStyle}
        className="baabaatarBox flexCenter"
      >
        {this.renderSheep(player, opacity)}
        <div className="playerInfo">
          <h3 className="fontFamilyBold playerName">{player.username}</h3>
          {subtitle && (
            <h3 className="fontFamilyBold fontColorGray winnerSubtitle">
              {subtitle.toUpperCase()}
            </h3>
          )}
        </div>
      </Col>
    )
  }
}

export default WinnerSheep



// WEBPACK FOOTER //
// ./src/components/thankyouWindow/winnerSheep/view.js